
if(document.getElementsByClassName("product-accordion").length){
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
acc[i].addEventListener("click", function() {
this.classList.toggle("active");
var panel = this.nextElementSibling;
if (panel.style.maxHeight){
panel.style.maxHeight = null;
} else {
panel.style.maxHeight = panel.scrollHeight + "px";
}
});
}
}

  $(function(){
    $('#faq_filter').change(function(){
      $('.faq-cat').hide();
      if($(this).val()=='all'){
        $('.faq-cat').show();
      }else{
        $('#'+$(this).val()).show();
      }
    });
  });


  function home_logo_slider(){
        if($(window).width() <= 640) {
        $('.home-logo x-flex').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows:true,
        });
    }else{
          if($('.home-logo x-flex').hasClass('slick-initialized')) {
        $('.home-logo x-flex').slick('unslick');
      }
      
    }
  }
$(function(){
  home_logo_slider();
  
  $(window).resize(function () {
    home_logo_slider();
  });
});